import React from "react";
import { ReactComponent as FiltersIcon } from "../../Assets/Icons/filtersIcon.svg";
import { ReactComponent as DownArrow } from "../../Assets/Icons/greyDownArrow.svg";

const FilterButton = ({ onClick, isOpen, activeCount = 0 }) => {
    const isActive = activeCount > 0;
    // CSS filter to convert grey/black to #00ADEF (Swoodle Blue)
    const blueFilter =
        "invert(55%) sepia(68%) saturate(1759%) hue-rotate(167deg) brightness(93%) contrast(93%)";
    const whiteFilter = "brightness(0) invert(1)";
    const currentFilter = isActive ? whiteFilter : blueFilter;

    return (
        <button
            onClick={onClick}
            className={`relative group flex justify-center items-center gap-2 border rounded-md p-3 text-lg font-medium outline-none h-[40px] transition-all duration-300
        ${isActive
                    ? "bg-[#00ADEF] text-white border-[#00ADEF]"
                    : "border-[#00ADEF] text-[#00ADEF] hover:bg-[#F0FBFF]"
                }`}
        >
            <div className="flex items-center gap-2">
                <div className="relative flex">
                    {isActive && (
                        <div className="absolute -top-[1px] -left-[2px] w-2 h-2 bg-red-500 rounded-full z-10"></div>
                    )}
                    <FiltersIcon
                        className="w-[20px] h-[20px] transition-all duration-300"
                        style={{ filter: currentFilter }}
                    />
                </div>
                <span className={`font-[500] text-[14px] font-poppins leading-[22px] ${isActive ? "text-white" : "text-[#00ADEF]"}`}>
                    Filters
                </span>
            </div>
            <DownArrow
                className={`transition-all duration-300 transform ${isOpen ? "rotate-180" : "rotate-0"}`}
                style={{ filter: currentFilter }}
            />
        </button>
    );
};

export default FilterButton;
